export default __webpack_public_path__ + "static/media/svg-6.41573b6c.svg";